import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-legal-form',
  templateUrl: './legal-form.component.html',
  styleUrls: ['./legal-form.component.scss']
})
export class LegalFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
